let MarkerClusterer = require('./markerclusterer');

module.exports = {
    MarkerClusterer
}